export enum FormMethod {

    GET = "GET",
    POST = "POST",
}
